/**
 * Bakery gallery carousel
 */

import Glide from '@glidejs/glide';

export default {

	/** @type {Glide} glide instance */
	inst: null,

	/** @type {Object} glide options */
	glideOpts: {
		type: 'carousel',
		perView: 1,
	},

	/**
	 * Initialize
	 */
	init() {
		if(!document.querySelector('#testimonials-carousel')) return;

		this.inst = new Glide('#testimonials-carousel', this.glideOpts);

		this.inst.on(['mount.after', 'run', 'resize'], () => this.resize());

		this.inst.mount();
	},

	/**
	 * Resize the container on slide change
	 */
	resize() {
		const { Html } = this.inst._c;
		const { track } = Html;
		const slide = Html.slides[this.inst.index];

		track.style.height = `${slide.offsetHeight}px`;
	},
}